export default "__VITE_ASSET__CbTBQusd__"